import React, { useMemo } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectKeyTerms } from "../../store/selectors";
import ModuleHeader from "../modules/ModuleHeader";
import { useClearCurrentTopic } from "../../hooks/useClearCurrentTopic";
import { useTranslation } from "react-i18next";
import Card from "../common/Card";

const SingleTermPage = () => {
  useClearCurrentTopic();
  const { id } = useParams();
  const terms = useSelector(selectKeyTerms);
  const { term, index } = useMemo(() => {
    const index = terms.findIndex((item) => item.contentKey === id);
    return { term: terms[index], index };
  }, [terms, id]);
  const { t } = useTranslation();

  const linkClass = `text-blue-600 hover:text-blue-800 uppercase`;

  if (!term) return <div />;

  return (
    <div>
      <ModuleHeader title={t("keyTerms")} />

      <Card>
        <div>
          <div>
            <div className="text-center">
              {term && term.fullContent && (
                <div dangerouslySetInnerHTML={{ __html: term.fullContent }} />
              )}
              {term && !term.fullContent && term.data.imageUrl && (
                <div>
                  <div>
                    <img
                      className="inline-block align-top"
                      src={term.data.imageUrl}
                      alt=" description"
                      width="375"
                      height="315"
                    />
                  </div>
                </div>
              )}
            </div>

            <div>
              <h1 className="text-lg font-bold">
                {(term && term.data && term.data.title) || (term && term.title)}
              </h1>
              <p className="mt-3">{term && term.description}</p>
            </div>
          </div>
        </div>

        <footer className="py-10 flex justify-between">
          {index === 0 ? (
            <div>
              <Link className={linkClass} to={`/app/key-terms`}>
                <i className="fas fa-chevron-circle-left mr-3" />
                {t("backToKeyTerms")}
              </Link>
            </div>
          ) : (
            <div>
              <Link
                className={linkClass}
                to={`/app/key-terms/${terms[index - 1].contentKey}`}
              >
                <i className="fas fa-chevron-circle-left mr-3" />
                {t("back")}
              </Link>
            </div>
          )}

          {index < terms.length - 1 && (
            <div>
              <Link
                className={linkClass}
                to={`/app/key-terms/${terms[index + 1].contentKey}`}
              >
                {t("continue")}
                <i className="fas fa-chevron-circle-right ml-3" />
              </Link>
            </div>
          )}
        </footer>
      </Card>
    </div>
  );
};

export default SingleTermPage;
